/**
 * Admin Tabs Navigation Component
 */
import { Users, MessageSquare, GraduationCap, Hospital, Upload } from "lucide-react";

export function AdminTabs({ 
  activeTab, 
  setActiveTab, 
  usersCount, 
  pendingDemosCount, 
  universitiesCount, 
  organizationsCount 
}) {
  const tabs = [
    { id: "users", label: "Users", icon: Users, count: usersCount },
    { id: "demos", label: "Demo Requests", icon: MessageSquare, count: `${pendingDemosCount} pending` },
    { id: "universities", label: "Universities", icon: GraduationCap, count: universitiesCount },
    { id: "organizations", label: "Organizations", icon: Hospital, count: organizationsCount },
    { id: "bulk", label: "Bulk Upload", icon: Upload, count: null },
  ];

  return (
    <div className="flex gap-2 border-b border-slate-700 overflow-x-auto">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`px-4 py-3 font-medium transition-colors whitespace-nowrap ${
            activeTab === tab.id
              ? "text-cyan-400 border-b-2 border-cyan-400"
              : "text-slate-400 hover:text-slate-200"
          }`}
          data-testid={`tab-${tab.id === "demos" ? "demos" : tab.id}`}
        >
          <tab.icon className="w-4 h-4 inline mr-2" />
          {tab.label} {tab.count !== null && `(${tab.count})`}
        </button>
      ))}
    </div>
  );
}
